<template>
	<v-row no-gutters>
		<v-col cols="12" class="text-center">
			<v-alert :value="true" color="transparent">
				<template v-slot:prepend>
					<v-icon large color="warning">fas fa-exclamation-circle</v-icon>
				</template>
				<span class="main_text_color--text" v-if="message">{{ message }}</span>
				<span class="main_text_color--text" v-else>{{ $t("global.nothing_to_display") }}</span>
				<template v-slot:append>
					<v-icon large color="warning">fas fa-exclamation-circle</v-icon>
				</template>
			</v-alert>
		</v-col>
	</v-row>
</template>

<script>
export default {
	data: () => ({}),
	props: {
		message: String,
	},
};
</script>
